'use strict';

var d3 = require('d3');

/**
 * Inactive Brushes
 *
 * Not active ("without handlers") brush in multi brush
 *
 * @param d3Helper
 * @returns {Function}
 * @constructor
 */
var InactiveBrushes = function InactiveBrushes(d3Helper) {
  return function () {
    var scales;
    var domainRange, ranges;
    var dispatch = d3.dispatch('inactivebrushclick');

    /**
     * Handler for mouse down
     * @param {number[]} range
     */
    var mouseDownHandler = function mouseDownHandler(range) {
      dispatch.inactivebrushclick(range);
    };

    /**
     * Binds events to brushes DOM elements
     * @param rect
     */
    function bindEvents(rect) {
      rect.on('mousedown', mouseDownHandler);
    }

    /**
     * Unbinds events
     * @param selection
     */
    function unbindEvents(selection) {
      selection.on('mousedown', null);
    }

    /**
     *
     * @param container
     */
    var brush = function brush(container) {
      if (!domainRange) {
        throw new Error('Unspecified domainRange');
      }
      var brushScale = d3.scale.linear().domain(domainRange).range(scales.xScale.rangeExtent());
      var padding = 3;
      var group = d3Helper.createGroupElement(container, 'inactive-brushes');
      var rects = group.selectAll('.inactive-brush').data(ranges);
      rects.enter().append('rect').call(bindEvents).attr('class', 'inactive-brush');
      rects.exit().call(unbindEvents).remove();
      rects.attr({
        'rx': 6,
        'ry': 6,
        'x': function x(d) {
          return brushScale(d[0]);
        },
        'y': -padding,
        'width': function width(d) {
          return brushScale(d[1]) - brushScale(d[0]);
        },
        'height': scales.yScale.range()[0] + 2 * padding
      });
    };

    /**
     * Sets/gets brush's domain ranges
     * @param value
     * @returns {brush}
     */
    brush.withDomainRange = function (value) {
      domainRange = value;
      return brush;
    };

    /**
     * Sets/gets brush's ranges
     * @param value
     * @returns {brush}
     */
    brush.withRanges = function (value) {
      ranges = value;
      return brush;
    };

    /**
     * Sets/gets brush's scales
     * @param value
     * @returns {brush}
     */
    brush.scales = function (value) {
      scales = value;
      return brush;
    };
    return d3.rebind(brush, dispatch, 'on');
  };
};
InactiveBrushes.$inject = ['d3Helper'];
module.exports = InactiveBrushes;